// 地図の初期中心を「物件がいちばん密集している地点」へ置くための計算。
//
// 県TOPの「地図から探す」は条件なしで開くので、サーバーが渡す既定の中心は県庁所在地になる。
// 県庁所在地に物件が無い県では、開いた直後の地図にピンが1本も無く「この県には物件が無い」と
// 読まれかねない。そこで受け取った物件から、半径内にいちばん多くの物件を抱える物件を選び、
// そこを中心にする。
//
// 【平均（重心）ではなく実在する物件を返す】物件が2か所に分かれている県で重心を取ると、
// どちらでもない中間地点（山の中や海の上）に中心が落ちる。候補を物件そのものに限れば、
// 少なくともその1件と周りの密集は必ず画面に入る。
//
// 【距離は平面近似で足りる】比べるのは数km単位の半径に入るかどうかだけなので、
// 緯度・経度1度の長さを定数で置き、経度だけ緯度の cos で縮める。
// 総当たり O(n²) だが、1県の物件は多くても数十件なので気にしなくてよい。
//
// Google Maps には依存させない（単体テストできるようにするため）。

const METERS_PER_LAT_DEG = 110574;
const METERS_PER_LNG_DEG = 111320;

const toRad = (deg) => (deg * Math.PI) / 180;

/** 2点間のおおよその距離（m） */
export const roughDistance = (a, b) => {
    const dy = (a.lat - b.lat) * METERS_PER_LAT_DEG;
    const dx =
        (a.lng - b.lng) * METERS_PER_LNG_DEG * Math.cos(toRad((a.lat + b.lat) / 2));
    return Math.sqrt(dx * dx + dy * dy);
};

/**
 * 半径 radiusMeters 以内に自分を含めて最も多くの点がある点を返す。点が無ければ null。
 * 同数のときは先に現れた点を返す（比較は厳密な「より多い」）。
 *
 * @param {Array<{lat: number, lng: number}>} points
 * @param {number} radiusMeters
 */
export const findDensestPoint = (points, radiusMeters) => {
    if (!points?.length) return null;

    // 緯度の差がこれを超える組は経度がどうであれ半径の外。cos を払う前に弾く
    const latSpan = radiusMeters / METERS_PER_LAT_DEG;
    let densest = null;
    let densestCount = 0;

    points.forEach((base) => {
        let count = 0;
        points.forEach((point) => {
            if (Math.abs(base.lat - point.lat) > latSpan) return;
            if (roughDistance(base, point) <= radiusMeters) count++;
        });
        if (count > densestCount) {
            densestCount = count;
            densest = base;
        }
    });

    return densest;
};
